import { render } from "./UploadShipmovement.vue?vue&type=template&id=4f4a07ea&scoped=true"
import script from "./UploadShipmovement.vue?vue&type=script&lang=js"
export * from "./UploadShipmovement.vue?vue&type=script&lang=js"

import "./UploadShipmovement.vue?vue&type=style&index=0&id=4f4a07ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4a07ea"]])

export default __exports__